const IconPlus = props => (
	<svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 12 12" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.99984 0.166748C6.27598 0.166748 6.49984 0.390606 6.49984 0.666748V5.50008H11.3332C11.6093 5.50008 11.8332 5.72394 11.8332 6.00008C11.8332 6.27622 11.6093 6.50008 11.3332 6.50008H6.49984V11.3334C6.49984 11.6096 6.27598 11.8334 5.99984 11.8334C5.72369 11.8334 5.49984 11.6096 5.49984 11.3334V6.50008H0.666504C0.390362 6.50008 0.166504 6.27622 0.166504 6.00008C0.166504 5.72394 0.390362 5.50008 0.666504 5.50008H5.49984V0.666748C5.49984 0.390606 5.72369 0.166748 5.99984 0.166748Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconPlus;
